module.exports = __webpack_public_path__ + "static/media/14UNEP11.10d17b81.jpg";